// Module
var code = "<div class=\"non-blocking-loading\" ng-style=\"{height: loadingHeight}\"> <img src=\"../../../../content/css/default/backoffice_loading.gif\"/> {{loadingText}} </div> ";
// Exports
module.exports = code;